module.exports = __webpack_public_path__ + "img/Implementos agrícolas.2bb621b9.webp";